import React, {FC, ReactNode} from 'react';
import clsx from 'clsx';

import style from './callout-block.module.styl';

interface CalloutBlockProps {
  children: ReactNode;
  className?: string;
  icon?: string;
  iconAltText?: string;
}

export const CalloutBlock: FC<CalloutBlockProps> = (props) => {
  return (
    <div className={clsx(style.block, props.className)}>
      {props.icon && (
        <div className={style.blockIcon}>
          <img src={props.icon} {...(props.iconAltText && {alt: props.iconAltText})} />
        </div>
      )}
      <div>{props.children}</div>
    </div>
  );
};
